/* eslint-diable */
<template>
  <v-app id="inspire" class="signUp">
    <v-content class="signUpWrap">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Signup form</v-toolbar-title>
                <v-spacer />

              </v-toolbar>
              <v-card-text>
                <v-form
                @submit.prevent="signUp"
                v-model="valid"
                @keydown.prevent.enter
                v-if="!loading">
                  <v-text-field
                    v-model="user.username"
                    label="Username"
                    :rules="notEmptyRules"
                    type="text"
                    required
                  />
                    <v-text-field
                    v-model="user.email"
                    label="Email"
                    :rules="notEmptyRules"
                    type="email"
                    required
                  />
                   <v-text-field
                    v-model="user.displayName"
                    label="Display Name"
                    :rules="notEmptyRules"
                    type="text"
                    required
                  />
                  <v-text-field
                    v-model="user.password"
                    :rules="notEmptyRules"
                    id="password"
                    label="Password"
                    type="password"
                    required
                  />
                  <v-text-field
                    v-model="user.confirmedPassword"
                    :rules="confirmPasswordRules"
                    id="password"
                    label="Confirm Password"
                    type="password"
                    required
                  />
                  <v-text-field
                    v-model="user.imageUrl"
                    label="Profile image"
                    :rules="notEmptyRules"
                    type="text"
                    required
                  />
                   <v-btn type="submit" color="primary">Sign Up</v-btn>
                </v-form>
                <v-progress-circular
                v-if="loading"
                :size="50"
                color="primary"
                indeterminate
                ></v-progress-circular>
              </v-card-text>
              <v-card-actions>
                <v-spacer />

              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'signup',
  props: {
    source: String,
  },
  data: (vm) => ({
    valid: false,
    user: {
      username: '',
      email: '',
      password: '',
      confirmedPassword: '',
      displayName: '',
      imageUrl: '',
    },
    notEmptyRules: [(value) => !!value || 'Cannot be empty'],
    confirmPasswordRules: [(confirmPassword) => confirmPassword === vm.user.password || 'Password must match'],
  }),
  computed: {
    ...mapState('users', { loading: 'isCreatePending' }),
  },
  methods: {
    signUp() {
      if (this.valid) {
        const { User } = this.$FeathersVuex.api;
        const user = new User(this.user);
        user.save().then((user) => {
          console.log(user);
          this.$router.push('/login');
        });
      }
    },
  },
  mounted(){
    if(location.pathname == '/login' || location.pathname == '/signup'){
      document.querySelector(".signUpWrap .v-content__wrap").style.background = "none";
      document.querySelector(".v-content__wrap").style.background = "none";
      document.querySelector(".v-content__wrap").style.marginTop = "0px";
      document.querySelector("#app > div > header").style.zIndex = "9";
    }
  }
};
</script>


<style scoped>
.theme--light.v-card {
    background-color: rgba(255, 255, 255, 0.8313725490196079);
    color: rgba(0,0,0,.87);
}
</style>